import api from "@/services/api";

/**
 * @description Servicio para interactuar con el endpoint /urgency-config.
 * Gestiona el CRUD de configuración de especialidades de urgencia.
 */
const urgencyConfigService = {};

const endpoint = "/urgency-config";

/**
 * @description Obtiene todas las configuraciones de urgencia
 * @returns {Promise<Array>} Lista de configuraciones
 */
urgencyConfigService.getAll = function () {
  return api.get(endpoint).then((res) => res.data);
};

/**
 * @description Crea una nueva configuración de urgencia
 * @param {Object} data - Datos de la configuración
 * @param {string} data.specialty - Nombre de la especialidad
 * @param {string} data.description - Descripción
 * @param {number} data.order - Orden de visualización
 * @param {boolean} data.enabled - Estado activo/inactivo
 * @returns {Promise<Object>} Configuración creada
 */
urgencyConfigService.create = function (data) {
  return api.post(endpoint, data).then((res) => res.data);
};

/**
 * @description Actualiza una configuración de urgencia existente
 * @param {string} id - ID de la configuración
 * @param {Object} data - Campos a actualizar
 * @returns {Promise<Object>} Configuración actualizada
 */
urgencyConfigService.update = function (id, data) {
  return api.put(`${endpoint}/${id}`, data).then((res) => res.data);
};

/**
 * @description Elimina una configuración de urgencia
 * @param {string} id - ID de la configuración
 * @returns {Promise<void>}
 */
urgencyConfigService.remove = function (id) {
  return api.delete(`${endpoint}/${id}`);
};

export default urgencyConfigService;
